module.exports = __webpack_public_path__ + "img/logo-icon.21dd217f.png";